<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">工事紐付け</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet class="pa-2" elevation="0">
				<v-form ref="form" v-model="valid">
					<table width="100%" class="mt-2 show-dialog-table show-dialog-table--form">
						<tbody>
							<!-- NOTE: サンプルデータを表示中 -->
							<!-- <ShowDetailRecord :columnName="'作業者名'" :value="worker.full_name" :tdStyle="{backgroundColor: 'white'}" />
						<ShowDetailRecord :columnName="'所属'" :value="worker.associated_company.name" :tdStyle="{backgroundColor: 'white'}" />
						<ShowDetailRecord :columnName="'期間'" :value="`${formatDate(schedule.planned_start_date)} ~ ${formatDate(schedule.planned_end_date)}`" :tdStyle="{backgroundColor: 'white'}" /> -->
							<ShowDetailRecord
								:columnName="'作業者名'"
								:value="'XX XX'"
								:tdStyle="{ backgroundColor: 'white' }"
							/>
							<ShowDetailRecord
								:columnName="'所属'"
								:value="'XXXX株式会社'"
								:tdStyle="{ backgroundColor: 'white' }"
							/>
							<ShowDetailRecord
								:columnName="'期間'"
								:value="`XXXX/XX/XX ~ XXXX/XX/XX`"
								:tdStyle="{ backgroundColor: 'white' }"
							/>
							<ShowDetailRecord :columnName="'対象工事'">
								<template v-slot:value>
									<v-select
										v-model="construction_id"
										:items="constructions"
										:rules="[rules.required]"
										item-text="name"
										item-value="id"
										background-color="white"
										outlined
										dense
										hide-details
									/>
								</template>
							</ShowDetailRecord>
						</tbody>
					</table>
				</v-form>
				<v-row no-gutters justify="center" class="mt-4">
					<v-col sm="3" cols="0" />
					<v-col class="text-center" sm="6" cols="12">
						<v-btn color="secondary" @click="save()" :disabled="!valid">
							<v-icon class="mr-1">mdi-pencil</v-icon>
							設定する
						</v-btn>
					</v-col>
					<v-col sm="3" cols="0" v-if="!$vuetify.breakpoint.xs">
						<v-btn class="ml-auto" text @click="showDialog = false"> キャンセル </v-btn>
					</v-col>
				</v-row>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		schedule: {
			type: null,
			required: true,
		},
		worker: {
			type: null,
			required: true,
		},
		constructions: {
			type: Array,
			required: false,
			default: () => {
				return []
			},
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			valid: false,
			construction_id: null,
			common,
			rules,
		}
	},
	methods: {
		save() {
			// TODO:
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
	watch: {
		schedule(newVal) {},
		deep: true,
	},
}
</script>